// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3Icie{display:-ms-flexbox;display:flex;-ms-flex:1 1;flex:1 1;width:100%;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;color:#95a1bd;font-weight:700;justify-content:space-between}._3Icie svg{fill:#6f7ea2;height:16px;width:16px}._26LlS{display:-ms-flexbox;display:flex;width:100%;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;padding:24px 0}._3H1FU{border-bottom:1px solid #e0e8f2;cursor:pointer;width:100%}._3VAW4{color:#0a385a}._22SWG{font-size:14px;font-size:1.4rem;font-weight:500;line-height:1.5;margin-bottom:24px}._1mkAj{margin-top:28px}", ""]);
// Exports
exports.locals = {
	"title_header": "_3Icie",
	"settingItem_header": "_26LlS",
	"settingItem_container": "_3H1FU",
	"optionHeader": "_3VAW4",
	"itemInfo": "_22SWG",
	"itemInfo--single": "_1mkAj"
};
module.exports = exports;
